<ng-container>
  <!-- Loading bar -->
  <fuse-loading-bar></fuse-loading-bar>

  <!-- Navigation -->
  @if (navigationService.navigation() && !layoutService.isAdminPage()) {
    <fuse-vertical-navigation
      class="print:hidden bg-light"
      [mode]="layoutService.isScreenSmall() ? 'over' : 'side'"
      [name]="'mainNavigation'"
      [navigation]="navigationService.filteredNavigation().default"
      [opened]="menuOpened()"
      (openedChanged)="saveNavigationStatus($event)" data-cy="main-navigation"
      >
      <!-- Navigation header hook -->
      <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full h-16 border-b relative top-px">
          <!-- Logo -->
          <div class="flex items-center justify-center w-full">
            <app-logo></app-logo>
          </div>
        </div>
      </ng-container>
    </fuse-vertical-navigation>
  }

  @if (navigationService.navigation && layoutService.isAdminPage()) {
    <fuse-vertical-navigation
      class="print:hidden bg-light"
      [mode]="layoutService.isScreenSmall() ? 'over' : 'side'"
      [name]="'adminNavigation'"
      [navigation]="navigationService.navigation().admin"
      [opened]="menuOpened()" data-cy="admin-navigation"
      >
      <!-- Navigation header hook -->
      <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full h-16 border-b relative top-px">
          <!-- Logo -->
          <div class="flex items-center justify-center w-full">
            <app-logo></app-logo>
          </div>
        </div>
      </ng-container>
    </fuse-vertical-navigation>
  }

  <!-- Wrapper -->
  <div class="flex flex-col flex-auto w-full min-w-0">
    <app-impersonation-banner></app-impersonation-banner>
    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b  print:hidden" [class.w-full]="isSidebarFullScreen">
      <!-- Navigation toggle button -->
      <button mat-icon-button (click)="toggleNavigation()" data-cy='toggle-main-navigation'>
        <mat-icon [svgIcon]="'feather:menu'"></mat-icon>
      </button>
      <!-- title -->
      <div class="flex flex-col">
        <app-page-title [title]="layoutService.title()"></app-page-title>
      </div>

      <!-- icon menu (search, notifications, user) -->
      <app-icon-menu-items class="flex pl-2 ml-auto space-x-0.5 sm:space-x-2"></app-icon-menu-items>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
      <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
      Otherwise, layout changes won't be registered and the view won't be updated! -->
      @if (true) {
        <router-outlet></router-outlet>
      }
    </div>

  </div>

</ng-container>

<!-- Quick chat -->
<!--<quick-chat  #quickChat="quickChat"></quick-chat>-->
